import { queryClient } from "@impero-com/common/utils/query_client";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { UpdatableTag } from "api/generated/model";
import { putTagsTagId } from "api/generated/tags/tags";

import { TAGS_QUERY_KEY } from "./useTagsQuery";

const STATUS_CODE_ERROR_CANNOT_RENAME_TO_INACTIVE_TAG = 462;
export class CannotRenameToInactiveTagError extends Error {}

interface UpdateTagMutationVars {
    tagId: string;
    updatableTag: UpdatableTag;
}

export const useUpdateTagMutation = () =>
    useMutation({
        mutationFn: (vars: UpdateTagMutationVars) =>
            putTagsTagId(vars.tagId, vars.updatableTag).then((response) => {
                if (response.status >= 200 && response.status <= 299) {
                    return response.data;
                } else {
                    return Promise.reject(
                        new Error(
                            `Failed to update a tag. HTTP status: ${response.status}`
                        )
                    );
                }
            }),
        onError: (err: AxiosError) => {
            if (
                err.response?.status ===
                STATUS_CODE_ERROR_CANNOT_RENAME_TO_INACTIVE_TAG
            ) {
                throw new CannotRenameToInactiveTagError();
            } else {
                throw err;
            }
        },
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY }),
    });
